document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('blog-search-input');
  const categorySelect = document.getElementById('blog_filter');
  const articlesContainer = document.querySelector('.blog-articles');
  const paginationWrapper = document.getElementById('pagination-wrapper');
  const loadAllButton = document.getElementById('load-all-articles');
  
  const originalArticles = Array.from(document.querySelectorAll('.blog-articles__article'));
  let isSearchActive = false;

  let noResultsMessage = document.querySelector('.no-results-message');
  if (!noResultsMessage) {
    noResultsMessage = document.createElement('div');
    noResultsMessage.className = 'no-results-message';
    noResultsMessage.innerHTML = '<p>No articles found matching your search.</p>';
    noResultsMessage.style.display = 'none';
    noResultsMessage.style.gridColumn = '1 / -1';
    noResultsMessage.style.textAlign = 'center';
    noResultsMessage.style.padding = '2rem';
    noResultsMessage.style.color = '#6B7280';
    if (articlesContainer) {
      articlesContainer.appendChild(noResultsMessage);
    }
  }

  let loadingMessage = document.querySelector('.loading-message');
  if (!loadingMessage) {
    loadingMessage = document.createElement('div');
    loadingMessage.className = 'loading-message';
    loadingMessage.innerHTML = '<p>Searching articles...</p>';
    loadingMessage.style.display = 'none';
    loadingMessage.style.gridColumn = '1 / -1';
    loadingMessage.style.textAlign = 'center';
    loadingMessage.style.padding = '2rem';
    loadingMessage.style.color = '#6B7280';
    if (articlesContainer) {
      articlesContainer.appendChild(loadingMessage);
    }
  }

  async function searchArticles(searchTerm, selectedCategory = '') {
    if (!searchTerm.trim() && !selectedCategory) {
      resetView();
      return;
    }

    isSearchActive = true;
    showLoading();
    
    try {
      const blogHandle = window.blogHandle || '';
      const searchUrl = `/search?q=${encodeURIComponent(searchTerm.trim())}&type=article&blog=${blogHandle}`;
      
      const response = await fetch(searchUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      
      const searchResults = doc.querySelectorAll('.blog-articles__article, .article, .search-result-item, .search__item, .grid__item');
      
      clearArticles();
      
      if (searchResults.length === 0) {
        showNoResults();
        return;
      }
      
      let matchingArticles = Array.from(searchResults);
      
      if (selectedCategory) {
        matchingArticles = matchingArticles.filter(article => {
          const articleTags = article.dataset.tags ? article.dataset.tags.toLowerCase() : '';
          return articleTags.includes(selectedCategory.toLowerCase());
        });
      }
      
      if (matchingArticles.length === 0) {
        showNoResults();
        return;
      }
      
      matchingArticles.forEach((article, index) => {
        let transformedArticle = transformSearchResult(article, index);
        
        if (index < 2) {
          transformedArticle.classList.add('article-featured');
          transformedArticle.classList.remove('article-grid');
        } else {
          transformedArticle.classList.add('article-grid');
          transformedArticle.classList.remove('article-featured');
        }
        
        articlesContainer.insertBefore(transformedArticle, noResultsMessage);
      });
      
      hideLoading();
      hidePagination();
      
    } catch (error) {
      showNoResults();
    }
  }

  function filterByCategory(selectedCategory) {
    if (!selectedCategory) {
      resetView();
      return;
    }
    
    const articles = Array.from(document.querySelectorAll('.blog-articles__article'));
    let visibleCount = 0;
    
    articles.forEach(article => {
      const articleTags = article.dataset.tags ? article.dataset.tags.toLowerCase() : '';
      
      if (articleTags.includes(selectedCategory.toLowerCase())) {
        article.style.display = '';
        visibleCount++;
      } else {
        article.style.display = 'none';
      }
    });
    
    if (visibleCount === 0) {
      showNoResults();
    } else {
      hideNoResults();
    }
    
    hidePagination();
  }

  function transformSearchResult(searchResult, index) {
    if (searchResult.classList.contains('blog-articles__article')) {
      return searchResult.cloneNode(true);
    }
    
    const articleWrapper = document.createElement('div');
    articleWrapper.className = 'blog-articles__article article';
    
    const clonedContent = searchResult.cloneNode(true);
    
    if (!clonedContent.classList.contains('article-card-wrapper')) {
      const cardWrapper = document.createElement('div');
      cardWrapper.className = 'article-card-wrapper card-wrapper underline-links-hover';
      
      clonedContent.classList.add('card', 'article-card', 'card--standard', 'card--media');
      
      cardWrapper.appendChild(clonedContent);
      articleWrapper.appendChild(cardWrapper);
    } else {
      articleWrapper.appendChild(clonedContent);
    }
    
    if (searchResult.dataset.tags) {
      articleWrapper.dataset.tags = searchResult.dataset.tags;
    }
    
    return articleWrapper;
  }

  function clearArticles() {
    const articles = document.querySelectorAll('.blog-articles__article');
    articles.forEach(article => article.remove());
  }

  function showLoading() {
    hideNoResults();
    loadingMessage.style.display = 'block';
  }

  function hideLoading() {
    loadingMessage.style.display = 'none';
  }

  function showNoResults() {
    hideLoading();
    noResultsMessage.style.display = 'block';
  }

  function hideNoResults() {
    noResultsMessage.style.display = 'none';
  }

  function hidePagination() {
    if (paginationWrapper) paginationWrapper.style.display = 'none';
    if (loadAllButton) loadAllButton.style.display = 'none';
  }

  function showPagination() {
    if (paginationWrapper) paginationWrapper.style.display = 'block';
  }

  function resetView() {
    isSearchActive = false;
    
    clearArticles();
    
    originalArticles.forEach((article, index) => {
      const clonedArticle = article.cloneNode(true);
      
      clonedArticle.className = 'blog-articles__article article';
      
      if (index < 2) {
        clonedArticle.classList.add('article-featured');
        clonedArticle.classList.remove('article-grid');
      } else {
        clonedArticle.classList.add('article-grid');
        clonedArticle.classList.remove('article-featured');
      }
      
      if (originalArticles[index].classList.contains('scroll-trigger')) {
        clonedArticle.classList.add('scroll-trigger', 'animate--slide-in');
        clonedArticle.setAttribute('data-cascade', '');
        clonedArticle.style.setProperty('--animation-order', index + 1);
      }
      
      articlesContainer.insertBefore(clonedArticle, noResultsMessage);
    });
    
    hideLoading();
    hideNoResults();
    showPagination();
  }

  function forceReset() {
    if (searchInput) searchInput.value = '';
    if (categorySelect) categorySelect.value = '';
    resetView();
  }

  window.blogResetView = forceReset;

  if (searchInput) {
    let searchTimeout;
    
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      const searchTerm = this.value.trim();
      const selectedCategory = categorySelect ? categorySelect.value : '';
      
      if (!searchTerm && !selectedCategory) {
        resetView();
        return;
      }
      
      searchTimeout = setTimeout(() => {
        searchArticles(searchTerm, selectedCategory);
      }, 300);
    });
  }

  if (categorySelect) {
    categorySelect.addEventListener('change', function() {
      const selectedCategory = this.value;
      const searchTerm = searchInput ? searchInput.value.trim() : '';
      
      if (!selectedCategory && !searchTerm) {
        resetView();
      } else if (searchTerm) {
        searchArticles(searchTerm, selectedCategory);
      } else {
        filterByCategory(selectedCategory);
      }
    });
  }
}); 